module.exports = "/virtual-football-league/img/amblems/right/logos/VILLARREAL.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/right/logos/VILLARREAL.png
// module id = 2234
// module chunks = 4